import { type FC, Fragment, type ReactNode, useEffect, useState } from 'react';
import { IS_PRERENDERING } from '@/base/constants';

export const ClientOnly: FC<{
  children: ReactNode;
  fallback?: ReactNode;
}> = ({ children, fallback = null }) => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    if (IS_PRERENDERING) return;
    setHydrated(true);
  }, []);

  if (hydrated)
    return <Fragment key={`children_${IS_PRERENDERING}`}>{children}</Fragment>;
  return <Fragment key={`fallback_${IS_PRERENDERING}`}>{fallback}</Fragment>;
};
